import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";

import iziToast from "izitoast";
import "izitoast/dist/css/iziToast.min.css";

const btn = document.querySelector("[data-start]");
const input = document.querySelector("#datetime-picker");

btn.disabled = true;

let userSelectedDate = null;
let timerId = null;

const refs = {
    days: document.querySelector("[data-days]"),
    hours: document.querySelector("[data-hours]"),
    minutes: document.querySelector("[data-minutes]"),
    seconds: document.querySelector("[data-seconds]"),
};

function addLeadingZero(value) {
    return String(value).padStart(2, "0");
}

function updateTimer({ days, hours, minutes, seconds }) {
    refs.days.textContent = addLeadingZero(days);
    refs.hours.textContent = addLeadingZero(hours);
    refs.minutes.textContent = addLeadingZero(minutes);
    refs.seconds.textContent = addLeadingZero(seconds);
}

const getTime = () => {
    const date = Date.now();
    if (userSelectedDate.getTime() <= date) {
        btn.disabled = true;

      iziToast.error({
          message: 'Please choose a date in the future',
            position:"topRight"
      });
        userSelectedDate = null;
        return;
    }

    btn.disabled = false;
}

const options = {
    enableTime: true,
    time_24hr: true,
    dateFormat: "Y-m-d H:i",
    defaultDate: new Date(),
    minuteIncrement: 1,
    onClose(selectedDates) {
        userSelectedDate = selectedDates[0];
        getTime();
    },
};
flatpickr("#datetime-picker", options);


btn.addEventListener("click", () => {
    if (!userSelectedDate) return;

    btn.disabled = true;
    input.disabled = true;

    if (timerId) clearInterval(timerId);

    const tick = () => {
        const ms = userSelectedDate - Date.now();

        if (ms <= 0) {
            clearInterval(timerId);
            timerId = null;

            updateTimer({ days: 0, hours: 0, minutes: 0, seconds: 0 });
            input.disabled = false;
            return;
        }
        updateTimer(convertMs(ms));
    };

    tick();
    timerId = setInterval(tick, 1000);
});

function convertMs(ms) {
  // Number of milliseconds per unit of time
  const second = 1000;
  const minute = second * 60;
  const hour = minute * 60;
  const day = hour * 24;

  const days = Math.floor(ms / day);
  const hours = Math.floor((ms % day) / hour);
  const minutes = Math.floor(((ms % day) % hour) / minute);
  const seconds = Math.floor((((ms % day) % hour) % minute) / second);
  return { days, hours, minutes, seconds };
}

